import { render } from "./SeoOverview.vue?vue&type=template&id=51be1042&scoped=true"
import script from "./SeoOverview.vue?vue&type=script&lang=js"
export * from "./SeoOverview.vue?vue&type=script&lang=js"

import "./SeoOverview.vue?vue&type=style&index=0&id=51be1042&scoped=true&lang=css"

import exportComponent from "/builds/site-palette/palette.site-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51be1042"]])

export default __exports__